import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { initCalendlyTracking } from "@/lib/calendly";
import Home from "@/pages/Home";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";
import AdminBlog from "@/pages/AdminBlog";

function App() {
  useEffect(() => {
    initCalendlyTracking();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
